import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import Benefits from '../components/Benefits';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { riseIn } from '../lib/scrollMotion';
import { consumePendingSection, scrollToSection } from '../lib/sectionNavigation';

function Home() {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const lockClasses = ['lenis', 'lenis-smooth', 'lenis-stopped'];
    lockClasses.forEach((cls) => {
      html.classList.remove(cls);
      body.classList.remove(cls);
    });
    html.style.removeProperty('overflow');
    html.style.removeProperty('overflow-y');
    body.style.removeProperty('overflow');
    body.style.removeProperty('overflow-y');

    const pendingSection = consumePendingSection();
    if (pendingSection) {
      window.requestAnimationFrame(() => {
        scrollToSection(pendingSection);
      });
      return;
    }

    if (window.location.hash) {
      const hashTarget = window.location.hash.slice(1);
      window.requestAnimationFrame(() => {
        scrollToSection(hashTarget, { behavior: 'auto' });
      });
    }
  }, []);

  return (
    <div className="min-h-screen w-full min-w-0 overflow-x-clip bg-white text-[#0f172a]">
      <Navbar />
      <main className="relative">
        <HeroSection />
        <motion.div {...riseIn(0, 70, 0.08)}>
          <Services />
        </motion.div>
        <motion.div {...riseIn(0, 70, 0.08)}>
          <HowItWorks />
        </motion.div>
        <motion.div {...riseIn(0, 70, 0.08)}>
          <Benefits />
        </motion.div>
        <motion.div {...riseIn(0, 70, 0.08)}>
          <Pricing />
        </motion.div>
        <motion.div {...riseIn(0, 70, 0.08)}>
          <FAQ />
        </motion.div>
        <motion.div {...riseIn(0, 70, 0.08)}>
          <Contact />
        </motion.div>
      </main>
      <motion.div {...riseIn(0, 70, 0.08)}>
        <Footer />
      </motion.div>
    </div>
  );
}

export default Home;
